/**
 * Flooded / Green-Orange-Violet.
 */ var GreenOrangeViolet = [
    /**
     * Blue Props.
     */ {
        variant: 'blue',
        size: '968',
        rotate: 50,
        blur: 21.3,
        x: '-2',
        y: '-558'
    },
    /**
     * Orange Props.
     */ {
        variant: 'orange',
        size: '1233',
        rotate: -130,
        blur: 21.3,
        x: '461',
        y: '512'
    },
    /**
     * Green Props.
     */ {
        variant: 'green',
        size: '922',
        rotate: 50,
        blur: 19.3,
        x: '-461',
        y: '-111'
    },
    /**
     * Violet Props.
     */ {
        variant: 'violet',
        size: '792',
        rotate: -140,
        blur: 19.3,
        x: '1077',
        y: '142'
    }
];

export { GreenOrangeViolet as default };
//# sourceMappingURL=green-orange-violet.es.js.map
